import React, { Component } from 'react';
import { SingleEntityState } from 'src/common';
import AdminFindMyBusRequestStats from 'src/common/entity/find-my-bus/AdminFindMyBusRequestStats';
import CircularProgress from 'material-ui/CircularProgress';
import { withTranslation } from 'react-i18next';
import FindMyBusRequestsTable from 'src/components/admin/find-my-bus/FindMyBusRequestsTable';

interface State {
    findMyBusRequestStats: SingleEntityState<AdminFindMyBusRequestStats>;
}

class FindMyBusRequestsAdministration extends Component<any, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            findMyBusRequestStats: {
                isFetching: false,
            },
        };
    }

    public render() {
        const { t } = this.props;
        const { findMyBusRequestStats } = this.state;
        if (findMyBusRequestStats.isFetching) return <CircularProgress />;

        return (
            <div>
                <FindMyBusRequestsTable t={t}></FindMyBusRequestsTable>
            </div>
        );
    }
}

export default withTranslation()(FindMyBusRequestsAdministration);
